import {useMemo} from 'react';
import {Chip} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles({
    container: {
        border: '1px solid #E7E7E7',
        borderRadius: 6,
        padding: '10px 12px',
    },
    title: {
        color: '#434343',
        fontSize: 24,
        fontWeight: 600,
        fontFamily: 'LoraSemiBold',
        lineHeight: '180%',
        textTransform: 'capitalize' as const,
    },
    chipList: {
        display: 'flex',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        minHeight: 40,
    },
    chip: {
        height: 33,
        borderRadius: 3,
        color: '#456d69',
        textTransform: 'capitalize',
        fontSize: 16,
        backgroundColor: '#e8edec',
    },
    li: {
        margin: '6px 12px 6px 0',
    },
});

interface GoalData {
    key: number;
    label: string;
}

type ClientGoalsProps = {
    investmentGoals: Array<string>;
};

export default function ClientGoals(props: ClientGoalsProps) {
    const {investmentGoals} = props;
    const classes = useStyles();

    const goals = useMemo<Array<GoalData>>(() => {
        if (!investmentGoals) return [];

        return investmentGoals
            .map((goal, index) => {
                let label = '';
                switch (goal) {
                    case 'savings':
                        label = 'Save Cash Tax Efficiently';
                        break;
                    case 'incomeReplacement':
                        label = 'Replace Income';
                        break;
                    case 'debtPayment':
                        label = 'Pay Off Debt';
                        break;
                    case 'healthEmergency':
                        label = 'Cover Health Emergencies';
                        break;
                    case 'inheritance':
                        label = 'Provide an Inheritance';
                        break;
                    default:
                        break;
                }

                return {key: index, label} as GoalData;
            })
            .filter((goal) => goal.label !== '');
    }, [investmentGoals]);

    return (
        <div className={classes.container}>
            <strong className={classes.title}>Client Goals</strong>
            <ul className={classes.chipList}>
                {goals.length === 0 ? (
                    <li className={classes.li}>
                        <span style={{color: '#838383', fontSize: 14, fontStyle: 'italic'}}>No goals selected</span>
                    </li>
                ) : (
                    goals.map((data) => (
                        <li key={data.key} className={classes.li}>
                            <Chip label={data.label} className={classes.chip} />
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
}
